import classNames from "classnames";
import React, { Component } from "react";
import { FormattedHTMLMessage } from "react-intl";
import classes from "./styles.module.scss";

interface IProps {
  id?: string;
  text?: string;
  big?: boolean;
  extraBig?: boolean;
  medium?: boolean;
  small?: boolean;
  extraSmall?: boolean;
  normal?: boolean;
  bold?: boolean;
  light?: boolean;
  uppercase?: boolean;
  lowercase?: boolean;
  left?: boolean;
  right?: boolean;
}

class Label extends Component<IProps & React.HTMLAttributes<HTMLDivElement>> {
  render() {
    const {
      id,
      text,
      className,
      big,
      medium,
      small,
      extraSmall,
      normal,
      bold,
      light,
      uppercase,
      lowercase,
      left,
      right,
      extraBig
    } = this.props;
    const labelClass = classNames(
      classes.Label,
      big ? classes.big : "",
      medium ? classes.medium : "",
      small ? classes.small : "",
      extraSmall ? classes.extraSmall : "",
      normal ? classes.normal : "",
      bold ? classes.bold : "",
      light ? classes.light : "",
      uppercase ? classes.uppercase : "",
      lowercase ? classes.lowercase : "",
      left ? classes.left : "",
      right ? classes.right : "",
      extraBig ? classes.extraBig : "",
      className
    );
    return (
      <div className={labelClass}>
        {id && <FormattedHTMLMessage id={id} />}
        {text && <label dangerouslySetInnerHTML={{ __html: text }} />}
      </div>
    );
  }
}
export default Label;
